<app-promotion [class.collapsed]="isSearchActive()"></app-promotion>

<div class="sticky-cart-info" #cartInfo [style.top.px]="effectiveTopBarHeight()">
    <app-cart-block #cartBlock></app-cart-block>
    <app-combo-guide-block></app-combo-guide-block>
</div>

@let hasCartBlock = cartBlock.isVisible();

<div
    class="sticky-search"
    [class.active]="isSearchActive()"
    [class.my]="(isSearchActive() && !hasCartBlock)"
    [style.top.px]="effectiveTopBarHeight() + cartInfoHeight()">
    <div class="search-box">
        <mat-icon>search</mat-icon>
        <input
            #searchInputEl
            type="text"
            [placeholder]="searchPlaceholder() | translate"
            [value]="searchInput()"
            (focus)="isSearchFocused.set(true)"
            (blur)="isSearchFocused.set(false)"
            (input)="searchInput.set($event.target.value ? $event.target.value : null)"
        >
        @if (isSearchActive()) {
            <img class="icon-xl" (click)="clearSearch(searchInputEl)" [src]="'close.svg' | themeSource" alt="close" />
        }
    </div>
</div>

<app-super-section-scroll [sections]="sectionsToDisplay()" [mode]="searchInput() ? 'slider' : 'grid'"></app-super-section-scroll>

@if (searchInput()) {
    <div class="search-items-list px">
        @if (searchResults().length) {
            @for (result of searchResults(); track result.item.id + (result.subSectionId ?? '')) {
                <app-item [item]="result.item" [subSectionId]="result.subSectionId" [isOptionalSubSection]="result.isOptionalSubSection" [sectionBadge]="result.superSectionName" [isCombo]="isCombo(result.superSectionId)"></app-item>
            }
        } @else {
            <app-search-empty-state></app-search-empty-state>
        }
    </div>
}
